<template>
  <div class="ui centered padded grid">

    <div
      v-if="!isLoaded"
      class="ui active dimmer">
      <div class="ui loader"></div>
    </div>
    <div
      v-if="isLoaded && !hasError"
      class="eight wide computer sixteen wide mobile column">

      <language-toggle/>

      <transition name="fade" mode="out-in">
        <component :is="consentComponentLookUp"/>
      </transition>

      <div class="ui tertiary bottom fixed tiny inverted menu">
        <p class="item">{{ localization.genericMessages.doNotRefresh }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ConsentManage from './ConsentManage'
import ConsentRequest from '../components/study/ConsentRequest'
import StudyIdentifier from './StudyIdentifier'
import LanguageToggle from '../components/common/LanguageToggle'

export default {
  name: 'Home',
  components: {
    ConsentManage,
    ConsentRequest,
    StudyIdentifier,
    LanguageToggle
  },
  data () {
    return {
      isLoaded: false,
      hasError: false
    }
  },
  computed: {
    ...mapState(['studyConsent', 'userStudyIdentifier']),
    consentComponentLookUp() {
      if (this.studyConsent === false) {
        return ConsentRequest
      } else if (this.studyConsent === true) {
        if (this.userStudyIdentifier === null) {
          return StudyIdentifier
        } else {
          return ConsentManage
        }
      } else {
        return null
      }
    }
  },
  mounted () {
    Promise.all([this.checkStudyConsent(), this.fetchQnBuddyBotId(), this.checkUserIdentifier()]).then(() => {
      this.isLoaded = true
    }, (error) => {
      this.isLoaded = true
      this.hasError = true
      Rollbar.error(error)
      this.$router.push({name: 'ErrorMessage'})
    })
  },
  methods: {
    ...mapActions(['checkStudyConsent', 'checkUserIdentifier', 'fetchQnBuddyBotId'])

  }
}
</script>

<style scoped>
  .ui.bottom.attached.secondary.button {
    box-shadow: 1px 0 0 0 #a9a9a9, -1px 0 0 0 #a9a9a9, 0 -1px 0 0 #a9a9a9, 0 1px 0 0 #a9a9a9 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue